<template>
  <div>
        <yetkidialog ref="yetkidialog"></yetkidialog>

    <v-form>
      <v-card flat>
        <v-layout row wrap>
          <v-flex xs12 sm12>
            <v-toolbar size="120px" dark color="info">
              <v-toolbar-title class="baslikfont">{{$t('Ticket-Report-Settings')}}</v-toolbar-title>
              <v-spacer></v-spacer>


              <v-tooltip bottom>
                <v-btn :disabled="!sayfayetki.Save" slot="activator" @click="Kaydet()" flat> <span
                    class="hidden-sm-and-down"> <span class="hidden-sm-and-down">{{$t("save_button")}}</span>
                  </span>

                </v-btn>
                <span v-if="!sayfayetki.Save">{{ $t('Limited-Authorization') }}</span>
                <span v-if="sayfayetki.Save">{{$t("save_button")}}</span>
              </v-tooltip>


            </v-toolbar>

          </v-flex>
          <v-container fluid>
            <v-layout row="" wrap="">

        <!-- <v-flex xs12 sm6 md2 pa-1>
          <v-card class="white--text">
            <v-card  flat="">
              <v-card-actions>
          <v-layout justify-space-between column>




                <v-text-field hide-details="" :label="$t('Discount-Account')" v-model="BiletRaporParametre.ParametreCari.IskontoHesap" color="-4"></v-text-field>
                <v-text-field hide-details="" :label="$t('AMADEUS-Account')" v-model="BiletRaporParametre.ParametreCari.AmadeusHesap" color="-4"></v-text-field>
                <v-text-field hide-details="" :label="$t('Domestic-Lines-Invoice-Mail')" v-model="BiletRaporParametre.ParametreFaturaDizayn.IcHatFaturaMail" color="-4"></v-text-field>
                <v-text-field hide-details="" :label="$t('International-Lines-Invoice-Mail')" v-model="BiletRaporParametre.ParametreFaturaDizayn.DisHatFaturaMail" color="-4"></v-text-field>
                <v-text-field hide-details="" :label="$t('Domestic-Lines-Invoice-PDF')" v-model="BiletRaporParametre.ParametreFaturaDizayn.IcHatFaturaPdf" color="-4"></v-text-field>
                <v-text-field hide-details="" :label="$t('International-Lines-Invoice-PDF')" v-model="BiletRaporParametre.ParametreFaturaDizayn.DisHatFaturaPdf" color="-4"></v-text-field>
                <v-text-field hide-details="" :label="$t('PDF-Path')" v-model="BiletRaporParametre.ParametrePath.PdfPath" color="-4"></v-text-field>
                <v-text-field hide-details="" :label="$t('Domestic-Lines-Invoice')" v-model="BiletRaporParametre.ParametreFaturaDizayn.IcHatFatura" color="-4"></v-text-field>
                <v-text-field hide-details="" :label="$t('Domestic-Lines-Foreign-Currency-Invoice')" v-model="BiletRaporParametre.ParametreFaturaDizayn.IcHatDovizFatura" color="-4"></v-text-field>
                <v-text-field hide-details="" :label="$t('International-Lines-Invoice')" v-model="BiletRaporParametre.ParametreFaturaDizayn.DisHatFatura" color="-4"></v-text-field>
                <v-text-field hide-details="" :label="$t('International-Lines-Foreign-Currency-Invoice')" v-model="BiletRaporParametre.ParametreFaturaDizayn.DisHatDovizFatura" color="-4"></v-text-field>
                <v-text-field hide-details="" :label="$t('Current-Actions-Invoice')" v-model="BiletRaporParametre.ParametreFaturaDizayn.CariHaraketFatura" color="-4"></v-text-field>



          </v-layout>

</v-card-actions>
            </v-card>
          </v-card>
        </v-flex> -->
<v-flex xs12 sm6 md5 pa-1>
          <v-card class="white--text">
            <v-card  flat="">
              <v-card-actions>
          <v-layout justify-space-between column>

                <!-- <v-switch :label="$t('Automatically-Transfer-THY-OPTAT-Tickets')" hide-details="" v-model="BiletRaporParametre.ParametreAktarim.OptatBiletOtomatikAktar"
                    ></v-switch> -->
                <!-- <v-switch label="THY (İç Hat) Elektronik Biletlerini Otomatik Aktar " hide-details="" v-model="BiletRaporParametre.ParametreAktarim.ElektronikBiletOtomatikAktar"
                    ></v-switch> -->
                <!-- <v-switch :label="$t('Add-Service-Amount-Ticket-Amount-ATLASJET-PEGASUS')" v-model="BiletRaporParametre.ParametreAktarim.AtlasPegasusServisBileteEkle"
                  hide-details=""   ></v-switch> -->
                <!-- <v-switch :label="$t('Automatically-Transfer-THY-OPTAT-Tickets-Current')" v-model="BiletRaporParametre.ParametreAktarim.TKIcHatOtomatikCariAktar"
                  hide-details=""   ></v-switch> -->


                <v-switch :label="$t('Change-Current-Invoiced-Ticket')" hide-details=""
                    ></v-switch>
                <v-switch :label="$t('Ask-Invoice-Approval-Question')" hide-details=""
                    ></v-switch>
                <!-- <v-switch :label="$t('Allow-Separate-Usage-Serial-Invoice')" v-model="BiletRaporParametre.ParametreFatura.FaturaAyriSeri"
                  hide-details=""   >
                </v-switch> -->
                <v-switch :label="$t('Show-Credit-Card-Number-Receipt')" v-model="BiletRaporParametre.ParametreFatura.DekontKrediKartNo"
                  hide-details=""   >
                </v-switch>
                <v-switch :label="$t('Mandatory-Select-Expense-Centre-Invoice')" hide-details=""
                    ></v-switch>

                <!-- <v-switch :label="$t('transfer-PEGASUS-SUN-EXPRESS-EX-Tickets')" v-model="BiletRaporParametre.ParametreAktarim.PegasusSunExpressExBiletAktarma"
                  hide-details=""   ></v-switch> -->


          </v-layout>
              </v-card-actions>
            </v-card>
          </v-card>
        </v-flex>

             <v-flex xs12 sm6 md5 pa-1>
          <v-card class="white--text">
            <v-card  flat="">
              <v-card-actions>
          <v-layout justify-space-between column>



                <v-switch :label="$t('Conduct-Corporate-Credit-Number-Control')" v-model="BiletRaporParametre.ParametreFatura.FirmaKartKontrol"
                  hide-details=""   ></v-switch>
                <v-switch :label="$t('Show-Corporate-Details-Receipt')" v-model="BiletRaporParametre.ParametreFatura.DekontSirket"
                  hide-details=""   ></v-switch>
                <!-- <v-switch :label="$t('SABRE-Corporate-Transfer')" hide-details="" v-model="BiletRaporParametre.ParametreAktarim.SabreKurumsal"
                    ></v-switch> -->
                <!-- <v-switch :label="$t('Credit-Transfer-ATLASJET-CASH-Tickets')" hide-details="" v-model="BiletRaporParametre.ParametreAktarim.AtlasCashBiletKrediliAktar"
                    ></v-switch> -->
                <!-- <v-switch :label="$t('Deduce-Penalty-Amount-Transfers')" hide-details=""
                    ></v-switch> -->
                  <v-switch :label="$t('Show-Ticket-Explanations-Receipt')" hide-details="" v-model="BiletRaporParametre.ParametreFatura.DekontBiletAciklama"
                    ></v-switch>
                <!-- <v-switch :label="$t('Hide-Titles')" hide-details="" v-model="BiletRaporParametre.ParametreFatura.DekontBaslikYok"
                    ></v-switch> -->
                <v-switch :label="$t('Show-Service-Amount-Receipt')"
                  hide-details=""   >
                </v-switch>
                <!-- <v-switch :label="$t('Show-Blank-Current-Search-Screen-Default')"
                  hide-details=""   >
                </v-switch> -->
              </v-layout>
              </v-card-actions>
            </v-card>
          </v-card>
        </v-flex>

            </v-layout>
          </v-container>

        </v-layout>
      </v-card>
    </v-form>


    <template>
      <v-card>
        <v-snackbar :timeout="timeout" :top="y === 'top'" :bottom="y === 'bottom'" :right="x === 'right'" :left="x === 'left'"
          :multi-line="mode === 'multi-line'" :vertical="mode === 'vertical'" v-model="snackbar">
          {{ text1 }}

          <v-btn flat color="pink" @click.native="snackbar = false">{{$t('Close')}}</v-btn>
        </v-snackbar>
      </v-card>
    </template>
  </div>
</template>

<script>
  import auth from '../../../api/auth'
  import helpers from "@/components/app/customcomp/helpers.js"
  import yetkidialog from "@/components/app/customcomp/yetkidialog.vue"

  export default {
    data() {
      return {
        sayfayetki: {
          Screen: false,
          Update: false,
          Save: false,
          Delete: false,
          Status: false,
          Message: null,
          islem: 0,
        },
        date: null,
        dateFormatted: null,
        menu: false,
        drawer: null,
        baslik: '',

        BiletRaporParametre: {
          ParametrePath: {
            AmadeusPath: null,
            GalileoPath: null,
            TKIchatPath: null,
            AtlasPath: null,
            OnurAirPath: null,
            PegasusPath: null,
            YedekPath: null,
            XmlPath: null,
            WordSpanPath: null,
            SabrePath: null,
            PdfPath: null
          },
          ParametreFaturaDizayn: {
            IcHatFaturaMail: null,
            DisHatFaturaMail: null,
            IcHatFaturaPdf: null,
            DisHatFaturaPdf: null,
            IcHatFatura: null,
            IcHatDovizFatura: null,
            DisHatFatura: null,
            DisHatDovizFatura: null,
            CariHaraketFatura: null,
            FaturaBoy: null,
            FaturaEn: null,
            DekontBoy: null,
            DekontEn: null
          },
          ParametreCari: {
            IskontoHesap: null,
            AmadeusHesap: null
          },
          ParametreAktarim: {
            OptatBiletOtomatikAktar: false,
            ElektronikBiletOtomatikAktar: false,
            AtlasCashBiletKrediliAktar: false,
            TKIcHatOtomatikCariAktar: false,
            GalileoDisOtomatikCariAktar: false,
            AmadeusDisOtomatikCariAktar: false,
            AmadeusGalileoCariEslestirmeYok: false,
            AmadeusServisOlmasadaCariAktar: false,
            AtlasPegasusServisBileteEkle: false,
            PegasusSunExpressExBiletAktarma: false,
            SabreKurumsal: false
          },
          ParametreFatura: {
            FaturaAyriSeri: false,
            DekontKrediKartNo: false,
            DekontBiletAciklama: false,
            DekontBaslikYok: false,
            FaturaPdf: false,
            FirmaKartKontrol: false,
            DekontSirket: false
          },
          ParametreFaturaBaglanti: {
            KullaniciAdi: null,
            Sifre: null,
            Url: null
          }
        },


        tumparametreler: [],
        dialog: false,



        text1: '',
        snackbar: false,
        y: 'top',
        x: 'right',
        mode: '',
        timeout: 6000
      }
    },
     beforeRouteEnter(to, from, next) {
      next(vm => {
        vm.prevRoute = from.path
      })
    },
    beforeMount: beforeMount,
     components: {
      yetkidialog
    },
mounted() {

      this.sayfayetki = helpers.pageScreenAuth(this.$route.name)

      if (this.sayfayetki.Status == true) {
        var credentials = JSON.parse(window.localStorage.getItem('credentials'));
         var params = {
      CompanyCode: credentials.SirketKodu
    }
    this.$http.post(auth.API_URL + 'api/TicketParametre/TicketParametreGet', params, {
      headers: {
        'Authorization': 'Bearer ' + auth.getAuthHeader()
      }
    }).then((response) => {
      this.tumparametreler = response.body
      this.BiletRaporParametre = response.body.RaporParametre


    }, (response) => {
      if (response.status === 0) {
        this.text = 'Service Unavailable'
        this.snackbar = true

      } else {
        this.text = 'Service Unavailable'
        this.snackbar = true

      }
    })


      } else {

        this.$refs.yetkidialog.open(this.sayfayetki.Message, this.sayfayetki.islem).then(sonuc => {

          if (sonuc == true) {

            if (this.prevRoute != null) {
              let url = '#' + this.prevRoute
              window.open(url, '_self')
            } else {
              let url = '#/'
              window.open(url, '_self')
            }
          } 

        });

      }
    },
    methods: {
      processFile(event) {

        var input = document.getElementById("fileUpload");
        var fReader = new FileReader();
        fReader.readAsDataURL(input.files[0]);
        fReader.onloadend = function (event) {

        }

        this.text1 = event.target.value
      },
      formatDate(date) {
        var str = date
        var n = str.search('.')
        if (n == 1) {
          return null
        } else {
          const [year, month, day] = date.split('-')
          return `${day}.${month}.${year}`
        }
      },
      parseDate(date) {
        if (!date) return null
        var str = date
        var n = str.search('-')
        var m = str.length
        if (n == 1) {
          const [month, day, year] = date.split('-')
          return `${year}-${month.padStart(2, '0')}-${day.padStart(2, '0')}`
        } else if (m == 8) {

        } else if (n == -1 && m != 8) {
          this.dateFormatted = getDateNow()
          this.date = getDateNow()
        } else {
          const [day, month, year] = date.split('.')
          return `${year}-${month.padStart(2, '0')}-${day.padStart(2, '0')}`
        }
      },
      onChange: onChange,
      getDateNow: getDateNow,
      toDateformat: toDateformat,
      Kaydet: Kaydet
    },
  }

  function Kaydet() {
    var credentials = JSON.parse(window.localStorage.getItem('credentials'));

    var params = {
      GenelParametre: this.tumparametreler.GenelParametre,
      RaporParametre: this.BiletRaporParametre,
      FirmaParametre: this.tumparametreler.FirmaParametre,
      SirketKodu: credentials.SirketKodu
    }


    this.$http.post(auth.API_URL + 'api/TicketParametre/TicketParametreAdd', params, {
      headers: {
        'Authorization': 'Bearer ' + auth.getAuthHeader()
      }
    }).then((response) => {

       this.text1 = this.$t(response.body.ResponseMessage)
      this.snackbar = true

    }, (response) => {
      if (response.status === 0) {
        this.text1 = 'Service Unavailable'
        this.snackbar = true

      } else {
        this.text1 = 'Service Unavailable'
        this.snackbar = true

      }
    })
  }



  function beforeMount() {

  }

  function toDateformat(dateStr) {
    var parts = dateStr.split("-");
    return (parts[2] + '.' + parts[1] + '.' + parts[0]);
  }

  function onChange(v) {
    var c = v.length
    var a = v
    if (c == 8) {
      var b = a[4] + a[5] + a[6] + a[7] + '-' + a[2] + a[3] + '-' + a[0] + a[1]
      this.date = b
    } else {
      this.dateFormatted = null
    }
  }


  function getDateNow() {
    var today = new Date();
    var dd = today.getDate();
    var mm = today.getMonth() + 1; //January is 0!
    var yyyy = today.getFullYear();

    if (dd < 10) {
      dd = '0' + dd
    }

    if (mm < 10) {
      mm = '0' + mm
    }
    today = dd + '-' + mm + '-' + yyyy
    return today
  }
</script>
<style>

</style>